import React, {useContext} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {useTableData} from "../../../../misc/scroller/Table";
import {Opening} from "../../../../api/Openings";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {CountBadge} from "../../shopdrawing/openings/DoorElevationHelpers";

export function WallTypeHeader() {
    const editCtx = useContext(EditContext);
    const data = useTableData<Opening|QuoteOpening>(editCtx.tableName)

    const missingElev = data.filter(d => {
        if(d.drawingWallLabel !== "" && !d.drawingWallLabelFile) return true;
        return false;
    }).length;

    return (
        <div style={{display: "flex", width: "100%"}}>
            <div style={{flex: 1}}>Wall Type</div>
            <CountBadge count={missingElev} label="Missing attachments" />
        </div>
    )
}